import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  button: {
    color: theme.palette.common.white,
    fontWeight: 'normal',
    minWidth: 180,
    textTransform: 'capitalize',
  },
  input: {
    marginLeft: theme.spacing(1),
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 1,
    width: '100%',
  },
  menuItemInput: {
    padding: 0,
    '&:hover': {
      backgroundColor: theme.palette.common.white,
    },
  },
  menuLoadingItem: {
    display: 'flex',
    justifyContent: 'center',
  },
}));

export default useStyles;
